export enum FormulaCardModoEnum {
    Listagem = 1,
    Editor = 2
}
